module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("AB")]), _vm._v(" "), _c('td', [_vm._v("Anchor Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ExpT")])]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Expository Times")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("GE")]), _vm._v(" "), _c('td', [_vm._v("The Brill Dictionary of Ancient Greek")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("JSNT")])]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Journal for the Study of the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("JSNTSup")]), _vm._v(" "), _c('td', [_vm._v("Journal for the Study of the New Testament Supplement Series")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIGTC")]), _vm._v(" "), _c('td', [_vm._v("New International Greek Testament Commentary")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("NTS")])]), _vm._v(" "), _c('td', [_c('i', [_vm._v("New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("SJT")])]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Scottish Journal of Theology")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WUNT")]), _vm._v(" "), _c('td', [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("ZTK")])]), _vm._v(" "), _c('td', [_c('i', [_vm._v("Zeitschrift für Theologie und Kirche")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa08521c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 72
// module chunks = 0